import { Button } from 'palette/Button';
import { CountBadge } from 'palette/Filters';
import { Icon } from 'palette/Icon';
import { ListItem } from 'palette/List';
import { useTranslation } from '@common/Hooks/useTranslation';

import './FiltersTypesItem.scss';

export function FiltersTypesItem({
    type,
    count,
    setCurrentFilterType,
    isInline
}) {
    const translate = useTranslation();
    const translationKey = type.replace('tag-', '');
    const baseLabel = translate(`listing.filter.${translationKey}.label`);

    const clickHandler = () => {
        setCurrentFilterType(type);
    };

    const getRightContent = () => (
        <>
            {
                count > 0 && (
                    <CountBadge
                        isColorBadge
                        className="mr-8"
                        count={count}
                    />
                )
            }
            <Icon
                color="black"
                name="palette_chevron_right"
            />
        </>
    );

    if (isInline) {
        return (
            <Button
                className="filters-types-item__button"
                label={baseLabel}
                size="medium"
                theme="secondary"
                onClick={clickHandler}
            />
        );
    }

    return (
        <ListItem
            label={baseLabel}
            rightContent={getRightContent()}
            onClick={clickHandler}
        />
    );
}
